import { toast } from 'react-toastify';

export default function useCopyToClipboard() {

  const handleCopy = (text) => {
    if (!navigator?.clipboard) {
      toast.error('Clipboard not supported');
      return false;
    }
    navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard');
  };

  return { handleCopy };
}
